module.exports = __webpack_public_path__ + "images/icons_v2/chevron-right-d1e4572b.svg";